import ItemCardMinimal from './itemCardMinimal'

export default ItemCardMinimal
